import { createActions } from "../../helpers/utils/createActions";
import { WORKFLOW } from "./actionTypes";

export const putWorkflowChangeStatus = createActions(WORKFLOW.PUT_WORKFLOW_CHANGE_STATUS);
export const cleanMessageWorkflow = () => ({ type: WORKFLOW.CLEAN_MESSAGE_WORKFLOW });